define.alias("shared/components/shared/social/linkedin-modal", "calendar/components/shared/social/linkedin-modal");